export class SetupMongoAtlasPrivateLinkRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceName",
            "baseName": "serviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "MongoAtlasPrivateLinkProvider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SetupMongoAtlasPrivateLinkRequest.attributeTypeMap;
    }
    constructor() {
    }
}
